"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApmsSdk = exports.host = exports.BasePlugin = void 0;
var reporter_1 = require("./reporter");
var api_1 = require("./api");
var log_1 = require("./utils/log");
var validators_1 = require("./utils/validators");
var basePlugin_1 = require("./plugin/basePlugin");
Object.defineProperty(exports, "BasePlugin", { enumerable: true, get: function () { return __importDefault(basePlugin_1).default; } });
var constants_1 = require("./constants");
Object.defineProperty(exports, "host", { enumerable: true, get: function () { return constants_1.host; } });
var ApmsSdk = (function () {
    function ApmsSdk(configs) {
        var _a;
        this.inited = false;
        this.enable = false;
        try {
            this.configs = configs;
            this.network = new api_1.Network({
                env: (_a = configs.environment) !== null && _a !== void 0 ? _a : 'test',
                de_app_id: configs.de_app_id,
                secret_key: configs.secret_key,
                report_host: configs.report_host,
            });
            this.reporter = new reporter_1.Reporter(configs, this.network);
            log_1.Logger.mute = !configs.logger;
            this.initConfigStatic();
        }
        catch (error) {
            log_1.Logger.log('Failed to init mdap sdk');
            log_1.Logger.error(error);
        }
    }
    ApmsSdk.prototype.initConfigStatic = function () {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_c) {
                try {
                    if (!((_a = this.reporter) === null || _a === void 0 ? void 0 : _a.fingerprint)) {
                        (_b = this.reporter) === null || _b === void 0 ? void 0 : _b.initFingerprint();
                    }
                    this.enable = true;
                    this.inited = true;
                }
                catch (error) {
                    log_1.Logger.log('Failed to init config');
                }
                return [2];
            });
        });
    };
    ApmsSdk.prototype.use = function (plugin) {
        var _a;
        if (!this.inited || !this.enable) {
            return;
        }
        var sampleRate = plugin.sample;
        if (!plugin.enable || Math.random() > sampleRate) {
            return;
        }
        (_a = this.reporter) === null || _a === void 0 ? void 0 : _a.register(plugin);
    };
    ApmsSdk.prototype.remove = function (plugin) {
        var _a;
        (_a = this.reporter) === null || _a === void 0 ? void 0 : _a.unregister(plugin);
    };
    ApmsSdk.prototype.addEntryTag = function (tag, value) {
        if (!tag) {
            log_1.Logger.warn('[APMS] addTag - tag is required');
            return;
        }
        if (!this.reporter) {
            return;
        }
        if (!(0, validators_1.isValidTag)(tag, value)) {
            log_1.Logger.warn('[APMS] addTag - invalid tag key or value');
            return;
        }
        this.reporter.tags[tag] = value.toString();
    };
    ApmsSdk.prototype.removeEntryTag = function (tag) {
        if (!tag) {
            log_1.Logger.warn('[APMS] removeTag - tag is required');
            return;
        }
        if (!this.reporter) {
            return;
        }
        if (Object.prototype.hasOwnProperty.call(this.reporter.tags, tag)) {
            delete this.reporter.tags[tag];
        }
    };
    return ApmsSdk;
}());
exports.ApmsSdk = ApmsSdk;
